import React from 'react';
import { Navigate } from 'react-router-dom';
import Base from './Base';

export default class Home extends Base {
    constructor(props) {
        super(props);
        this.state = { role: null };
    }

    componentDidMount() {

        this.httpPost('api/v1/common/get', {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    const role = data.global.user.role;
                    this.setState({ role,data });
                }
            });
    }

    render() {
        const { role } = this.state;
        if (role === null) return this.renderLoading();

        if (role === 1 || role === 2) return <Navigate to="/dashboard-pro" />;
        if (role === 3) return <Navigate to="/calendar" />; 
        return <Navigate to="/login" />;
    }
}